import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _a5c14310 = () => interopDefault(import('../../../pages/cookie-list.vue' /* webpackChunkName: "pages/cookie-list" */))
const _77002223 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _14c2fba7 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _4d663993 = () => interopDefault(import('../../../pages/strings.vue' /* webpackChunkName: "pages/strings" */))
const _bbbc68b0 = () => interopDefault(import('../../../pages/interactive-demo/_slug.vue' /* webpackChunkName: "pages/interactive-demo/_slug" */))
const _216a10b6 = () => interopDefault(import('../../../pages/_contentSection/blog.vue' /* webpackChunkName: "pages/_contentSection/blog" */))
const _6ac5b248 = () => interopDefault(import('../../../pages/_contentSection/events.vue' /* webpackChunkName: "pages/_contentSection/events" */))
const _0c82533c = () => interopDefault(import('../../../pages/_contentSection/home.vue' /* webpackChunkName: "pages/_contentSection/home" */))
const _a7ec904e = () => interopDefault(import('../../../pages/_contentSection/press-releases.vue' /* webpackChunkName: "pages/_contentSection/press-releases" */))
const _294e44b3 = () => interopDefault(import('../../../pages/_contentSection/blog-post/_slug.vue' /* webpackChunkName: "pages/_contentSection/blog-post/_slug" */))
const _5ece0866 = () => interopDefault(import('../../../pages/_contentSection/page/_slug.vue' /* webpackChunkName: "pages/_contentSection/page/_slug" */))
const _94b0df76 = () => interopDefault(import('../../../pages/_contentSection/press-release/_slug.vue' /* webpackChunkName: "pages/_contentSection/press-release/_slug" */))
const _466845f7 = () => interopDefault(import('../../../pages/_contentSection/product/_slug.vue' /* webpackChunkName: "pages/_contentSection/product/_slug" */))
const _738ed23c = () => interopDefault(import('../../../pages/_contentSection/products/_slug.vue' /* webpackChunkName: "pages/_contentSection/products/_slug" */))
const _3f59935c = () => interopDefault(import('../../../pages/_contentSection/product/_category1/_slug.vue' /* webpackChunkName: "pages/_contentSection/product/_category1/_slug" */))
const _1b7896f2 = () => interopDefault(import('../../../pages/_contentSection/products/_category1/_slug.vue' /* webpackChunkName: "pages/_contentSection/products/_category1/_slug" */))
const _a7867c50 = () => interopDefault(import('../../../pages/_contentSection/product/_category1/_category2/_slug.vue' /* webpackChunkName: "pages/_contentSection/product/_category1/_category2/_slug" */))
const _0b78c083 = () => interopDefault(import('../../../pages/_contentSection/products/_category1/_category2/_slug.vue' /* webpackChunkName: "pages/_contentSection/products/_category1/_category2/_slug" */))
const _d540cd5a = () => interopDefault(import('../../../pages/_contentSection/product/_category1/_category2/_category3/_slug.vue' /* webpackChunkName: "pages/_contentSection/product/_category1/_category2/_category3/_slug" */))
const _590251c8 = () => interopDefault(import('../../../pages/_contentSection/products/_category1/_category2/_category3/_slug.vue' /* webpackChunkName: "pages/_contentSection/products/_category1/_category2/_category3/_slug" */))
const _7c1f89b9 = () => interopDefault(import('../../../pages/_contentSection/product/_category1/_category2/_category3/_category4/_slug.vue' /* webpackChunkName: "pages/_contentSection/product/_category1/_category2/_category3/_category4/_slug" */))
const _9b6b33b8 = () => interopDefault(import('../../../pages/_contentSection/products/_category1/_category2/_category3/_category4/_slug.vue' /* webpackChunkName: "pages/_contentSection/products/_category1/_category2/_category3/_category4/_slug" */))
const _68b63054 = () => interopDefault(import('../../../pages/_contentSection/product/_category1/_category2/_category3/_category4/_category5/_slug.vue' /* webpackChunkName: "pages/_contentSection/product/_category1/_category2/_category3/_category4/_category5/_slug" */))
const _75a9f309 = () => interopDefault(import('../../../pages/_contentSection/products/_category1/_category2/_category3/_category4/_category5/_slug.vue' /* webpackChunkName: "pages/_contentSection/products/_category1/_category2/_category3/_category4/_category5/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/cookie-list/",
    component: _a5c14310,
    pathToRegexpOptions: {"strict":true},
    name: "cookie-list"
  }, {
    path: "/en/",
    component: _77002223,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/ja/",
    component: _77002223,
    pathToRegexpOptions: {"strict":true},
    name: "index___ja"
  }, {
    path: "/ko/",
    component: _77002223,
    pathToRegexpOptions: {"strict":true},
    name: "index___ko"
  }, {
    path: "/search/",
    component: _14c2fba7,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/strings/",
    component: _4d663993,
    pathToRegexpOptions: {"strict":true},
    name: "strings"
  }, {
    path: "/zh/",
    component: _77002223,
    pathToRegexpOptions: {"strict":true},
    name: "index___zh"
  }, {
    path: "/en/cookie-list/",
    component: _a5c14310,
    pathToRegexpOptions: {"strict":true},
    name: "cookie-list___en"
  }, {
    path: "/en/search/",
    component: _14c2fba7,
    pathToRegexpOptions: {"strict":true},
    name: "search___en"
  }, {
    path: "/en/strings/",
    component: _4d663993,
    pathToRegexpOptions: {"strict":true},
    name: "strings___en"
  }, {
    path: "/ja/cookie-list/",
    component: _a5c14310,
    pathToRegexpOptions: {"strict":true},
    name: "cookie-list___ja"
  }, {
    path: "/ja/search/",
    component: _14c2fba7,
    pathToRegexpOptions: {"strict":true},
    name: "search___ja"
  }, {
    path: "/ja/strings/",
    component: _4d663993,
    pathToRegexpOptions: {"strict":true},
    name: "strings___ja"
  }, {
    path: "/ko/cookie-list/",
    component: _a5c14310,
    pathToRegexpOptions: {"strict":true},
    name: "cookie-list___ko"
  }, {
    path: "/ko/search/",
    component: _14c2fba7,
    pathToRegexpOptions: {"strict":true},
    name: "search___ko"
  }, {
    path: "/ko/strings/",
    component: _4d663993,
    pathToRegexpOptions: {"strict":true},
    name: "strings___ko"
  }, {
    path: "/zh/cookie-list/",
    component: _a5c14310,
    pathToRegexpOptions: {"strict":true},
    name: "cookie-list___zh"
  }, {
    path: "/zh/search/",
    component: _14c2fba7,
    pathToRegexpOptions: {"strict":true},
    name: "search___zh"
  }, {
    path: "/zh/strings/",
    component: _4d663993,
    pathToRegexpOptions: {"strict":true},
    name: "strings___zh"
  }, {
    path: "/",
    component: _77002223,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/en/interactive-demo/:slug?/",
    component: _bbbc68b0,
    pathToRegexpOptions: {"strict":true},
    name: "interactive-demo-slug___en"
  }, {
    path: "/ja/interactive-demo/:slug?/",
    component: _bbbc68b0,
    pathToRegexpOptions: {"strict":true},
    name: "interactive-demo-slug___ja"
  }, {
    path: "/ko/interactive-demo/:slug?/",
    component: _bbbc68b0,
    pathToRegexpOptions: {"strict":true},
    name: "interactive-demo-slug___ko"
  }, {
    path: "/zh/interactive-demo/:slug?/",
    component: _bbbc68b0,
    pathToRegexpOptions: {"strict":true},
    name: "interactive-demo-slug___zh"
  }, {
    path: "/interactive-demo/:slug?/",
    component: _bbbc68b0,
    pathToRegexpOptions: {"strict":true},
    name: "interactive-demo-slug"
  }, {
    path: "/en/:contentSection/blog/",
    component: _216a10b6,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog___en"
  }, {
    path: "/en/:contentSection/events/",
    component: _6ac5b248,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-events___en"
  }, {
    path: "/en/:contentSection/home/",
    component: _0c82533c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-home___en"
  }, {
    path: "/en/:contentSection/press-releases/",
    component: _a7ec904e,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-releases___en"
  }, {
    path: "/ja/:contentSection/blog/",
    component: _216a10b6,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog___ja"
  }, {
    path: "/ja/:contentSection/events/",
    component: _6ac5b248,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-events___ja"
  }, {
    path: "/ja/:contentSection/home/",
    component: _0c82533c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-home___ja"
  }, {
    path: "/ja/:contentSection/press-releases/",
    component: _a7ec904e,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-releases___ja"
  }, {
    path: "/ko/:contentSection/blog/",
    component: _216a10b6,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog___ko"
  }, {
    path: "/ko/:contentSection/events/",
    component: _6ac5b248,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-events___ko"
  }, {
    path: "/ko/:contentSection/home/",
    component: _0c82533c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-home___ko"
  }, {
    path: "/ko/:contentSection/press-releases/",
    component: _a7ec904e,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-releases___ko"
  }, {
    path: "/zh/:contentSection/blog/",
    component: _216a10b6,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog___zh"
  }, {
    path: "/zh/:contentSection/events/",
    component: _6ac5b248,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-events___zh"
  }, {
    path: "/zh/:contentSection/home/",
    component: _0c82533c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-home___zh"
  }, {
    path: "/zh/:contentSection/press-releases/",
    component: _a7ec904e,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-releases___zh"
  }, {
    path: "/en/:contentSection/blog-post/:slug?/",
    component: _294e44b3,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog-post-slug___en"
  }, {
    path: "/en/:contentSection/page/:slug?/",
    component: _5ece0866,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-page-slug___en"
  }, {
    path: "/en/:contentSection/press-release/:slug?/",
    component: _94b0df76,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-release-slug___en"
  }, {
    path: "/en/:contentSection/product/:slug?/",
    component: _466845f7,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-slug___en"
  }, {
    path: "/en/:contentSection/products/:slug?/",
    component: _738ed23c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-slug___en"
  }, {
    path: "/ja/:contentSection/blog-post/:slug?/",
    component: _294e44b3,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog-post-slug___ja"
  }, {
    path: "/ja/:contentSection/page/:slug?/",
    component: _5ece0866,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-page-slug___ja"
  }, {
    path: "/ja/:contentSection/press-release/:slug?/",
    component: _94b0df76,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-release-slug___ja"
  }, {
    path: "/ja/:contentSection/product/:slug?/",
    component: _466845f7,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-slug___ja"
  }, {
    path: "/ja/:contentSection/products/:slug?/",
    component: _738ed23c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-slug___ja"
  }, {
    path: "/ko/:contentSection/blog-post/:slug?/",
    component: _294e44b3,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog-post-slug___ko"
  }, {
    path: "/ko/:contentSection/page/:slug?/",
    component: _5ece0866,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-page-slug___ko"
  }, {
    path: "/ko/:contentSection/press-release/:slug?/",
    component: _94b0df76,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-release-slug___ko"
  }, {
    path: "/ko/:contentSection/product/:slug?/",
    component: _466845f7,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-slug___ko"
  }, {
    path: "/ko/:contentSection/products/:slug?/",
    component: _738ed23c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-slug___ko"
  }, {
    path: "/zh/:contentSection/blog-post/:slug?/",
    component: _294e44b3,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog-post-slug___zh"
  }, {
    path: "/zh/:contentSection/page/:slug?/",
    component: _5ece0866,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-page-slug___zh"
  }, {
    path: "/zh/:contentSection/press-release/:slug?/",
    component: _94b0df76,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-release-slug___zh"
  }, {
    path: "/zh/:contentSection/product/:slug?/",
    component: _466845f7,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-slug___zh"
  }, {
    path: "/zh/:contentSection/products/:slug?/",
    component: _738ed23c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-slug___zh"
  }, {
    path: "/en/:contentSection/product/:category1?/:slug?/",
    component: _3f59935c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-slug___en"
  }, {
    path: "/en/:contentSection/products/:category1?/:slug?/",
    component: _1b7896f2,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-slug___en"
  }, {
    path: "/ja/:contentSection/product/:category1?/:slug?/",
    component: _3f59935c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-slug___ja"
  }, {
    path: "/ja/:contentSection/products/:category1?/:slug?/",
    component: _1b7896f2,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-slug___ja"
  }, {
    path: "/ko/:contentSection/product/:category1?/:slug?/",
    component: _3f59935c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-slug___ko"
  }, {
    path: "/ko/:contentSection/products/:category1?/:slug?/",
    component: _1b7896f2,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-slug___ko"
  }, {
    path: "/zh/:contentSection/product/:category1?/:slug?/",
    component: _3f59935c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-slug___zh"
  }, {
    path: "/zh/:contentSection/products/:category1?/:slug?/",
    component: _1b7896f2,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-slug___zh"
  }, {
    path: "/en/:contentSection/product/:category1?/:category2?/:slug?/",
    component: _a7867c50,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-slug___en"
  }, {
    path: "/en/:contentSection/products/:category1?/:category2?/:slug?/",
    component: _0b78c083,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-slug___en"
  }, {
    path: "/ja/:contentSection/product/:category1?/:category2?/:slug?/",
    component: _a7867c50,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-slug___ja"
  }, {
    path: "/ja/:contentSection/products/:category1?/:category2?/:slug?/",
    component: _0b78c083,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-slug___ja"
  }, {
    path: "/ko/:contentSection/product/:category1?/:category2?/:slug?/",
    component: _a7867c50,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-slug___ko"
  }, {
    path: "/ko/:contentSection/products/:category1?/:category2?/:slug?/",
    component: _0b78c083,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-slug___ko"
  }, {
    path: "/zh/:contentSection/product/:category1?/:category2?/:slug?/",
    component: _a7867c50,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-slug___zh"
  }, {
    path: "/zh/:contentSection/products/:category1?/:category2?/:slug?/",
    component: _0b78c083,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-slug___zh"
  }, {
    path: "/en/:contentSection/product/:category1?/:category2?/:category3?/:slug?/",
    component: _d540cd5a,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-slug___en"
  }, {
    path: "/en/:contentSection/products/:category1?/:category2?/:category3?/:slug?/",
    component: _590251c8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-slug___en"
  }, {
    path: "/ja/:contentSection/product/:category1?/:category2?/:category3?/:slug?/",
    component: _d540cd5a,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-slug___ja"
  }, {
    path: "/ja/:contentSection/products/:category1?/:category2?/:category3?/:slug?/",
    component: _590251c8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-slug___ja"
  }, {
    path: "/ko/:contentSection/product/:category1?/:category2?/:category3?/:slug?/",
    component: _d540cd5a,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-slug___ko"
  }, {
    path: "/ko/:contentSection/products/:category1?/:category2?/:category3?/:slug?/",
    component: _590251c8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-slug___ko"
  }, {
    path: "/zh/:contentSection/product/:category1?/:category2?/:category3?/:slug?/",
    component: _d540cd5a,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-slug___zh"
  }, {
    path: "/zh/:contentSection/products/:category1?/:category2?/:category3?/:slug?/",
    component: _590251c8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-slug___zh"
  }, {
    path: "/en/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _7c1f89b9,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-slug___en"
  }, {
    path: "/en/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _9b6b33b8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-slug___en"
  }, {
    path: "/ja/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _7c1f89b9,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-slug___ja"
  }, {
    path: "/ja/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _9b6b33b8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-slug___ja"
  }, {
    path: "/ko/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _7c1f89b9,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-slug___ko"
  }, {
    path: "/ko/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _9b6b33b8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-slug___ko"
  }, {
    path: "/zh/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _7c1f89b9,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-slug___zh"
  }, {
    path: "/zh/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _9b6b33b8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-slug___zh"
  }, {
    path: "/en/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _68b63054,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-category5-slug___en"
  }, {
    path: "/en/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _75a9f309,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-category5-slug___en"
  }, {
    path: "/ja/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _68b63054,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-category5-slug___ja"
  }, {
    path: "/ja/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _75a9f309,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-category5-slug___ja"
  }, {
    path: "/ko/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _68b63054,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-category5-slug___ko"
  }, {
    path: "/ko/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _75a9f309,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-category5-slug___ko"
  }, {
    path: "/zh/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _68b63054,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-category5-slug___zh"
  }, {
    path: "/zh/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _75a9f309,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-category5-slug___zh"
  }, {
    path: "/:contentSection/blog/",
    component: _216a10b6,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog"
  }, {
    path: "/:contentSection/events/",
    component: _6ac5b248,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-events"
  }, {
    path: "/:contentSection/home/",
    component: _0c82533c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-home"
  }, {
    path: "/:contentSection/press-releases/",
    component: _a7ec904e,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-releases"
  }, {
    path: "/:contentSection/blog-post/:slug?/",
    component: _294e44b3,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-blog-post-slug"
  }, {
    path: "/:contentSection/page/:slug?/",
    component: _5ece0866,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-page-slug"
  }, {
    path: "/:contentSection/press-release/:slug?/",
    component: _94b0df76,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-press-release-slug"
  }, {
    path: "/:contentSection/product/:slug?/",
    component: _466845f7,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-slug"
  }, {
    path: "/:contentSection/products/:slug?/",
    component: _738ed23c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-slug"
  }, {
    path: "/:contentSection/product/:category1?/:slug?/",
    component: _3f59935c,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-slug"
  }, {
    path: "/:contentSection/products/:category1?/:slug?/",
    component: _1b7896f2,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-slug"
  }, {
    path: "/:contentSection/product/:category1?/:category2?/:slug?/",
    component: _a7867c50,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-slug"
  }, {
    path: "/:contentSection/products/:category1?/:category2?/:slug?/",
    component: _0b78c083,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-slug"
  }, {
    path: "/:contentSection/product/:category1?/:category2?/:category3?/:slug?/",
    component: _d540cd5a,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-slug"
  }, {
    path: "/:contentSection/products/:category1?/:category2?/:category3?/:slug?/",
    component: _590251c8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-slug"
  }, {
    path: "/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _7c1f89b9,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-slug"
  }, {
    path: "/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:slug?/",
    component: _9b6b33b8,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-slug"
  }, {
    path: "/:contentSection/product/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _68b63054,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-product-category1-category2-category3-category4-category5-slug"
  }, {
    path: "/:contentSection/products/:category1?/:category2?/:category3?/:category4?/:category5?/:slug?/",
    component: _75a9f309,
    pathToRegexpOptions: {"strict":true},
    name: "contentSection-products-category1-category2-category3-category4-category5-slug"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
